import React from 'react'

const ProductLocation = props=>{
    return (
        <div className="productLocation">
          <span className='spanOne'>
            {`Home > Phones & Tablets > Mobile Phones > Smartphones > Android Phones
          > `}
          </span>
          
          <span className='spanTwo'>
          {`Galaxy A51 6.5-Inch (4GB,128GB ROM) Android 10.0,(48MP +12MP + 5MP +
            5MP) + 32MP Dual SIM - Prism Crush Black`}
          </span>
        </div>
    )
}

export default ProductLocation
